export const ENV_HEADER_TITLE = process.env.VUE_APP_HEADER_TITLE === undefined ? 'Student Activities Payments System' : process.env.VUE_APP_HEADER_TITLE
export const ENV_LOGIN_TITLE = process.env.VUE_APP_LOGIN_TITLE === undefined ? 'Student Activities Payments System [SAPS]' : process.env.VUE_APP_LOGIN_TITLE
export const ENV_USE_PASSWORD = process.env.VUE_APP_USE_PASSWORD === undefined ? 'true' : process.env.VUE_APP_USE_PASSWORD
export const ENV_PLACEHOLDER_USERNAME = process.env.VUE_APP_PLACEHOLDER_USERNAME === undefined ? '' : process.env.VUE_APP_PLACEHOLDER_USERNAME
export const ENV_PLACEHOLDER_PASSWORD = process.env.VUE_APP_PLACEHOLDER_PASSWORD === undefined ? '' : process.env.VUE_APP_PLACEHOLDER_PASSWORD
export const ENV_PLACEHOLDER_PAYMENT_DOCNUM = process.env.VUE_APP_PLACEHOLDER_PAYMENT_DOCNUM === undefined ? 'Input invoice/billing statement number without prefix and leading zeros' : process.env.VUE_APP_PLACEHOLDER_PAYMENT_DOCNUM
export const ENV_PLACEHOLDER_PAYMENT_PURPOSE = process.env.VUE_APP_PLACEHOLDER_PAYMENT_PURPOSE === undefined ? 'Input name of activity, project, or purpose' : process.env.VUE_APP_PLACEHOLDER_PAYMENT_PURPOSE
export const ENV_MAINTENANCE_WINDOW = process.env.VUE_APP_MAINTENANCE_WINDOW === undefined ? '0_02_00_04_00' : process.env.VUE_APP_MAINTENANCE_WINDOW

export const API_URL_CORE = process.env.VUE_APP_API_CORE === undefined ? 'https://saps-core.amitscps.com/zpi/' : process.env.VUE_APP_API_CORE
export const API_URL_GL = process.env.VUE_APP_API_GL === undefined ? 'https://saps-gl.amitscps.com/zpi/' : process.env.VUE_APP_API_GL
export const API_URL_AP = process.env.VUE_APP_API_AP === undefined ? 'https://saps-ap.amitscps.com/zpi/' : process.env.VUE_APP_API_AP
export const API_URL_HR = process.env.VUE_APP_API_HR === undefined ? 'https://saps-hr.amitscps.com/zpi/' : process.env.VUE_APP_API_HR
export const API_URL_EOC = process.env.VUE_APP_API_EOC === undefined ? 'https://saps-eoc.amitscps.com/zpi/' : process.env.VUE_APP_API_EOC
export const API_URL_SY = process.env.VUE_APP_API_SY === undefined ? 'https://saps-sy.amitscps.com/zpi/' : process.env.VUE_APP_API_SY
export const API_URL_RADIUS = process.env.VUE_APP_API_RADIUS === undefined ? '/' : process.env.VUE_APP_API_RADIUS

export default {
  ENV_HEADER_TITLE,
  ENV_LOGIN_TITLE,
  ENV_USE_PASSWORD,
  ENV_PLACEHOLDER_USERNAME,
  ENV_PLACEHOLDER_PASSWORD,
  ENV_PLACEHOLDER_PAYMENT_DOCNUM,
  ENV_PLACEHOLDER_PAYMENT_PURPOSE,
  ENV_MAINTENANCE_WINDOW,
  API_URL_CORE,
  API_URL_GL,
  API_URL_AP,
  API_URL_HR,
  API_URL_EOC,
  API_URL_SY,
  API_URL_RADIUS
}
